export default {"src":"/_next/static/media/pw_logo.2ede722f.svg","height":331,"width":877,"blurWidth":0,"blurHeight":0};